/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { Label } from "reactstrap";
import { secondsToDurationString } from "../../../util/DateTime";

const GuestMetrics = ({data}) => {
  const metrics = data?.data;
  return metrics ? (
    <div className="px-3 fill-container d-flex justify-content-between flex-column">
      <Label className="flex-dynamic w-100 text-center" style={{ fontSize: "22px" }}>Guest Metrics</Label>
      <div className="flex-dynamic d-flex justify-content-between">
        <div className="flex-40">
          <Label className="text-muted no-spacing" tag="h5">Guests Online</Label>
          <Label className="no-spacing" tag="h4">{metrics.guestsOnline}</Label>
        </div>
        <div className="flex-20" />
        <div className="flex-40">
          <Label className="text-muted no-spacing" tag="h5">Total Guests</Label>
          <Label className="no-spacing" tag="h4">{metrics.totalGuests}</Label>
        </div>
      </div>
      <div className="flex-dynamic">
        <Label className="text-muted no-spacing" tag="h5">Average Visit Duration</Label>
        <Label className="no-spacing" tag="h4">{metrics.averageVisitDuration !== 0 ? secondsToDurationString(metrics.averageVisitDuration) : "0"}</Label>
      </div>
    </div>
  ) : null;
};

export default GuestMetrics;
